// src/components/resources/templates/FormatSelector.tsx

import { type TemplateDeliveryFormatId, TemplateDeliveryFormats } from '~/lib/resources/types/templates'
import { formatIcons } from '~/components/resources/templates/FormatIcons'
import { cn } from '~/lib/utils'

interface FormatSelectorProps {
  formats: TemplateDeliveryFormatId[]
  activeFormat: TemplateDeliveryFormatId
  onFormatSelect: (format: TemplateDeliveryFormatId) => void
  className?: string
}

export function FormatSelector({ 
  formats, 
  activeFormat, 
  onFormatSelect,
  className 
}: FormatSelectorProps): JSX.Element {
  return (
    <div className={cn('grid gap-4 sm:grid-cols-2 lg:grid-cols-3', className)}>
      {formats.map((format) => {
        const formatConfig = TemplateDeliveryFormats[format.toUpperCase() as keyof typeof TemplateDeliveryFormats]
        if (!formatConfig) return null

        const Icon = formatIcons[format]

        return (
          <button
            key={format}
            onClick={() => onFormatSelect(format)}
            className={cn(
              'flex items-center gap-3 rounded-lg border border-gray-200 p-4 text-left transition-colors hover:bg-gray-50 dark:border-gray-800 dark:hover:bg-gray-800/50',
              activeFormat === format && 'border-blue-500 bg-blue-50 dark:border-blue-400 dark:bg-blue-900/20'
            )}
          >
            <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-gray-100 dark:bg-gray-800">
              <Icon className={cn(
                'h-6 w-6',
                activeFormat === format ? 'text-blue-600 dark:text-blue-400' : 'text-gray-600 dark:text-gray-400'
              )} />
            </div>
            <div>
              <div className="font-medium text-gray-900 dark:text-white">
                {formatConfig.name}
              </div>
              <div className="text-sm text-gray-500 dark:text-gray-400">
                {formatConfig.description}
              </div>
            </div>
          </button>
        )
      })}
    </div>
  )
} 